import { render, staticRenderFns } from "./AccountPassword.vue?vue&type=template&id=4ac919d5&scoped=true"
import script from "./AccountPassword.vue?vue&type=script&lang=js"
export * from "./AccountPassword.vue?vue&type=script&lang=js"
import style0 from "./AccountPassword.vue?vue&type=style&index=0&id=4ac919d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac919d5",
  null
  
)

export default component.exports